// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "_" + {"205":"71a0954","620":"2b3c420","658":"ac03afa"}[chunkId] + ".css";
};